import React, { useState } from 'react';
import { StyledRow } from './styles';
import Goals from './goals';
import Steps from './steps';

const GoalsRow = ({ isCollapsed, record }) => {
  const [ selectedGoal, setSelectedGoal ] = useState();

  return (
    <StyledRow>
      <Goals
        isCollapsed={isCollapsed}
        goals={record.goals}
        selectedGoal={selectedGoal}
        setSelected={setSelectedGoal}
      />

      <Steps 
        goal={selectedGoal}
        isCollapsed={isCollapsed}
      />
    </StyledRow>
  );
};

export default GoalsRow;
